import { useSelector } from "react-redux";
import { SBAAutoComplete, SBAComboBox } from "../UiComponents/SBADropDown"
import { useRef, useState } from "react";
import { SBADrawer } from "../UiComponents/SBADrawer";
import { sbaAxios } from "../utils/sbaAxios";
import { AgGridReact } from "ag-grid-react";
import { useEffect } from "react";
import { getAllUserPageRightsByTenant, getUsersByTenant, updatedPageAccess } from "../../config/apiConfig";
import { SBNotify } from "../utils/sbNotify";

export const PageLevelToUser = () => {
    const Gstate = useSelector(state => state) || {};
    const [selectedTenant, setSelectedTenant] = useState({});
    const [drawerState, setDrawerState] = useState(false);
    const [userGridData, setuserGridData] = useState([]);
    const [selectedPage, setSelectedPage] = useState({});
    const [editUser, setEditUser] = useState([]);
    const [viewUser, setViewUser] = useState([]);
    const [noEditUsers, setNoEditUser] = useState([]);
    const [noViewUsers, setNoViewUser] = useState([]);
    const [filteredViewer, setFilteredViewer] = useState([]);
    const [filteredEditor, setFilteredEditor] = useState([]);
    const [render,setRender]=useState(true);
    const editUserGridRef = useRef();
    const viewUserGridRef = useRef();
    const selectedEditUserGridRef = useRef();
    const selectedViewUserGridRef = useRef();
    const tenantsData = Gstate?.AdminPermissions?.TenantData || [];

    useEffect(() => { setSelectedTenant(tenantsData[0]) }, []);
    useEffect(() => { getUserRights() }, [selectedTenant,render]);


    const tenantDDChange = (e) => {
        setSelectedTenant(e.value);
    };
    function getUserRights() {
        const tenantId = selectedTenant.TenantId;
        if (tenantId) {
            sbaAxios({ url: `${getAllUserPageRightsByTenant}${tenantId}` }).then(resposne => {
                setuserGridData(resposne)
            }).catch(error => {
                console.log(error);
            });
        };
    };
    const editSelectedPageAccess = (pageLevel) => {
        setFilteredViewer([]);
        setFilteredEditor([]);
        setSelectedPage(pageLevel);
        const viewUserId = pageLevel.ViewAccessIDList.length > 0 ? pageLevel.ViewAccessIDList.split(",") : [];
        const viewUserName = pageLevel.ViewAccessList.length > 0 ? pageLevel.ViewAccessList.split(",") : [];
        const viewUserData = viewUserId.map((item, index) => {
            return {
                UserId: item,
                UserName: viewUserName[index]
            }
        })

        const editUserId = pageLevel.EditAccessIDList.length > 0 ? pageLevel.EditAccessIDList.split(",") : [];
        const editUserName = pageLevel.EditAccessList.length > 0 ? pageLevel.EditAccessList.split(",") : [];
        const editUserData = editUserId.map((item, index) => {
            return {
                UserId: item,
                UserName: editUserName[index]
            }
        })

        setViewUser([...viewUserData]);
        setEditUser([...editUserData]);
        sbaAxios({ url: `${getUsersByTenant}${selectedTenant.TenantId}` }).then(resposne => {
            setNoViewUser(resposne);
            setNoEditUser(resposne);
            // const existingViewUser = viewUserData.map(user => user.UserId);
            // const FilteredViewUser= resposne.filter(user=>!existingViewUser.includes(user.UserId));
            // setNoViewUser(FilteredViewUser);
            // const existingEditUser = editUserData.map(user => user.UserId);
            // const FilteredEditUser= resposne.filter(user=>!existingEditUser.includes(user.UserId));
            // setNoEditUser(FilteredEditUser);
        }).catch(e => {
            console.log(e);
        })
        setDrawerState(true);
    }
    const ActionsRenderer = (props) => {
        return (
            <div className="actions-cell">
                <i className="fas fa-edit" style={{ color: "#47A547", margin: "0 8px", cursor: "pointer" }} onClick={() => { editSelectedPageAccess(props.data) }}></i>
            </div>)

    };
    const DrawerGridStyles = { width: '40%', height: '250px' };
    const userGridDef = [
        {
            field: "AccessKeyName",
            headerName: "AccessKeyName",
        },
        {
            field: "EditAccessList",
            headerName: "Edit Access Users"
        },
        {
            field: "ViewAccessList",
            headerName: "View Access Users"
        },
        {
            field: "",
            headerName: "Actions",
            maxWidth: 150,
            cellRenderer: ActionsRenderer
        }
    ];
    const defUserColDef = {
        flex: 1,
        filter: 'agTextColumnFilter' ,floatingFilter: true,resizable:true
    };
    const addSelectedUser = (e, type) => {
        if (type === 'View') {
            if (viewUser.findIndex(user => user.UserId == e.data.UserId) === -1) {
                const SelectedUser = noViewUsers.find(user => (user.UserId === e.data.UserId));
                setViewUser(value => [SelectedUser, ...value]);                
            }
            else{
                SBNotify({ type: "warning", Msg: "The User Already Exist" });
            }
        }
        else if (type === "Edit") {
            if (editUser.findIndex(user => user.UserId == e.data.UserId) === -1) {
                const SelectedUser = noEditUsers.find(user => (user.UserId === e.data.UserId));
                setEditUser(value => [SelectedUser, ...value]);
            }
            else{
                SBNotify({ type: "warning", Msg: "The User Already Exist" });
            }
        }

    };
    const removerSelecteduser = (e, type) => {
        if (type === 'View') {
            const filterViewUsers = viewUser.filter(user => !(user.UserId === e.data.UserId));
            setViewUser(filterViewUsers);
        }
        else if (type === "Edit") {
            const filterEditUser = editUser.filter(user => !(user.UserId === e.data.UserId));
            setEditUser(filterEditUser);
        }

    };
    const updateUserPageAcess = () => {
        const saveData = {
            "userId": 0,
            "userName": "string",
            "createdBy": 0,
            "modifiedBy": 0,
            "accessKeyId": selectedPage.AccessKeyId,
            "tenantId": selectedTenant.TenantId,
            "accessKeyName": selectedPage.AccessKeyName,
            "isEditAllowed": true,
            "isViewAllowed": true,
            "isDeleteAllowed": true,
            "editAccessList": editUser.map(user => user.UserName).join(","),
            "viewAccessList": viewUser.map(user => user.UserName).join(","),
            "editAccessIDList": editUser.map(user => user.UserId).join(","),
            "viewAccessIDList": viewUser.map(user => user.UserId).join(","),
        };
        sbaAxios({ url: `${updatedPageAccess}`, method: 'post', data: saveData }).then(response => {
            SBNotify({ Msg: "Page level Acess Updated Successfully" });
            resetState();
           setRender(!render);
        }).catch(e => {
            console.log(e);
        });
       
    };
    const setDataSourceToGrid = (e, Type) => {
        const inputedValue = e.target.value;
        if (inputedValue.length === 0) {
            if (Type === "View")
                setFilteredViewer([]);
            if (Type === "Edit")
                setFilteredEditor([]);
        }
        else if (Type === "View") {
            setFilteredViewer(noViewUsers.filter(user => user.UserName.toLowerCase().includes(inputedValue.toLowerCase())));
        }
        else if (Type === "Edit") {
            setFilteredEditor(noEditUsers.filter(user => user.UserName.toLowerCase().includes(inputedValue.toLowerCase())));
        }
    };
    const resetState = () => {
        setFilteredEditor([]);
        setFilteredViewer([]);
        setNoEditUser([]);
        setNoViewUser([]);
        setDrawerState(false);
    };
    const AddUser = (ref, data, setData) => {
        if (ref.current.api.getSelectedRows().length > 0) {
            const selectedRow = ref.current.api.getSelectedRows()[0];
            if (data.findIndex(user => user.UserId == selectedRow.UserId) === -1) {
                setData([selectedRow, ...data])
            }else{
                SBNotify({ type: "warning", Msg: "The User Already Exist" });
            }
        }

    };
    const removeUser = (ref, data, setData) => {
        if (ref.current.api.getSelectedRows().length > 0) {
            const recordToRemove = ref.current.api.getSelectedRows()[0];
            const filteredData = data.filter(item => parseInt(item.UserId) !== parseInt(recordToRemove.UserId));
            setData([...filteredData]);
        }
    };
    return (
        <>
            <div className="col-lg-4 mt-4">
                <label
                    className="ms-2 fw-semibold fs-12"
                >
                    Select Tenant
                </label>
                <SBAComboBox data={tenantsData} textField={'TenantName'} valueField={'TenantId'} value={selectedTenant} onChange={tenantDDChange} />
            </div>
            <div className="ag-theme-alpine" style={{ width: '100%', height: '700px' }}>
                <AgGridReact
                    columnDefs={userGridDef}
                    rowData={userGridData}
                    defaultColDef={defUserColDef}
                    pagination={true}
                    paginationPageSize={20}
                    rowSelection="Single"
                />
            </div>

            <SBADrawer open={drawerState} setOpen={setDrawerState} title={"Edit Page Level Access"} size={"lg"}>
                <div className="row">
                    <label
                        className="label col-md-4"
                    >
                        Key Name
                    </label>
                    <label
                        className="label col-md-4"
                    >
                        Tenant Name
                    </label>
                </div>
                <div className="row mb-4">
                    <label
                        className="fw-medium col-md-4"
                    >
                        {selectedPage.AccessKeyName}
                    </label>
                    <label
                        className="fw-medium col-md-4"
                    >
                        {selectedTenant.TenantName}
                    </label>
                </div>

                <div className="w-75" >
                    <label
                        className="label"
                    >
                        View User Rights
                    </label>
                    <input type="text" className="w-50 input-default form-control" onKeyUp={(e) => { setDataSourceToGrid(e, "View") }} />
                </div>
                <div className="d-flex gap-1 mb-2">
                    <div className="ag-theme-alpine" style={DrawerGridStyles}>
                        <AgGridReact
                            columnDefs={[ {
                                field: "UserName",
                                headerName: "User View Rights",
                            }]}
                            rowData={filteredViewer}
                            defaultColDef={defUserColDef}
                            rowSelection="single"
                            ref={viewUserGridRef}
                            onRowDoubleClicked={(e) => { addSelectedUser(e, "View") }}
                        />
                    </div>
                    <div className="d-flex flex-column justify-content-center gap-2">
                        <button className="p-sm-btn" onClick={() => { AddUser(viewUserGridRef, viewUser, setViewUser) }}> <i class="fa-solid fa-arrow-right"></i> </button>
                        <button className="s-sm-btn" onClick={() => { removeUser(selectedViewUserGridRef, viewUser, setViewUser) }}><i class="fa-solid fa-arrow-left"></i></button>
                    </div>

                    <div className="ag-theme-alpine" style={DrawerGridStyles}>
                        <AgGridReact
                            columnDefs={[ {
                                field: "UserName",
                                headerName: "View Users",
                            }]}
                            rowData={viewUser}
                            defaultColDef={defUserColDef}
                            rowSelection="single"
                            ref={selectedViewUserGridRef}
                            onRowDoubleClicked={(e) => { removerSelecteduser(e, "View") }}

                        />
                    </div>
                </div>
                <div className="w-75">
                    <label
                        className="label"
                    >
                        Edit User Rights
                    </label>
                    <input type="text" className="w-50 input-default form-control" onKeyUp={(e) => { setDataSourceToGrid(e, "Edit") }} />
                </div>
                <div className="d-flex gap-1">
                    <div className="ag-theme-alpine" style={DrawerGridStyles}>
                        <AgGridReact
                            columnDefs={[ {
                                field: "UserName",
                                headerName: "User Edit Rights",
                            }]}
                            rowData={filteredEditor}
                            defaultColDef={defUserColDef}
                            rowSelection="single"
                            onRowDoubleClicked={(e) => { addSelectedUser(e, "Edit") }}
                            ref={editUserGridRef}

                        />
                    </div>
                    <div className="d-flex flex-column justify-content-center gap-2">
                        <button className="p-sm-btn" onClick={() => { AddUser(editUserGridRef, editUser, setEditUser) }}><i class="fa-solid fa-arrow-right"></i></button>
                        <button className="s-sm-btn" onClick={() => { removeUser(selectedEditUserGridRef, editUser, setEditUser) }}><i class="fa-solid fa-arrow-left"></i></button>
                    </div>
                    <div className="ag-theme-alpine" style={DrawerGridStyles}>
                        <AgGridReact
                            columnDefs={[ {
                                field: "UserName",
                                headerName: "Edit Users",
                            }]}
                            rowData={editUser}
                            defaultColDef={defUserColDef}
                            rowSelection="single"
                            ref={selectedEditUserGridRef}
                            onRowDoubleClicked={(e) => { removerSelecteduser(e, "Edit") }}

                        />
                    </div>
                </div>
                <div className="d-flex gap-3 mt-2">
                    <button className="s-sm-btn" onClick={() => { resetState() }}>Cancel</button>
                    <button className="p-sm-btn" onClick={() => { updateUserPageAcess() }}>Update</button>
                </div>
            </SBADrawer>
        </>
    )
}